<!--Organisaationäkymä koulutustyypeille, joille määritelty Pepissä 'lottaOrganisationView = true' tms.-->



<!--organisaationimi otsikkona-->
<h1 *ngIf="isLoaded && organisation">{{globals.getLocalizedValueForTitle(organisation?.name)}}</h1>

<!--koulutustyyppi otsikkona-->
<h1 *ngIf="isLoaded && organisations && organisations.length > 0 && this.header">{{globals.getLocalizedValueForTitle(this.header)}}</h1>

<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<mat-card *ngIf="organisation?.description?.valueFi || organisation?.description?.valueSv" class="education-type-description">
    <app-markdown [body]="globals.getLocalizedValueForTitle(organisation?.description)"></app-markdown>
</mat-card>

<div class="nav-content " *ngIf="isLoaded && organisations && organisations.length > 0 && parent">
    <mat-nav-list *ngIf="!period">

        <a mat-list-item  routerLink="/{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedValue(parent.name))}}/{{globals.toKebabCase(globals.getLocalizedValue(organisation.name))}}/{{educationTypeId}}/{{organisation.id}}" *ngFor="let organisation of organisations">
            {{globals.getLocalizedValue(organisation.name)}}
        </a>
        <mat-divider></mat-divider>
    </mat-nav-list>
    <mat-nav-list *ngIf="period">

        <a mat-list-item  routerLink="/{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedValue(parent.name))}}/{{globals.toKebabCase(globals.getLocalizedValue(organisation.name))}}/{{educationTypeId}}/{{organisation.id}}" [queryParams]="{period: period}" *ngFor="let organisation of organisations">
            {{globals.getLocalizedValue(organisation.name)}}
        </a>
        <mat-divider></mat-divider>
    </mat-nav-list>
    
</div>

<!-- näitä kahta kuuluukin kutsua aina, jotta nähdään onko aliorganisaatioita-->
<organisations-by-education-type-and-organisation *ngIf="parent && organisation"  [education-type-id]="educationTypeId" [organisation-unit-id]="organisationUnitId" [period] = "period"></organisations-by-education-type-and-organisation>

<educations-by-education-type-and-organisation *ngIf="parent && organisation" [education-type-id]="educationTypeId" [organisation-unit-id]="organisationUnitId" [period] = "period"></educations-by-education-type-and-organisation>

<!--uniarts-->
<!--tämä ajetaan virheellisesti, koska näkymä renderöityy ennen kuin parent-->
<ng-container *ngIf="profileName.startsWith('uniarts')" >
    <education-types-by-organisation [organisation-unit-id]="organisationUnitId" [period] = "period"></education-types-by-organisation>
</ng-container>